import React from 'react';
import * as S from './styles';

interface ShellSpinnerProps {
  userThemeEnabled?: boolean;
}

const ShellSpinner: React.FC<ShellSpinnerProps> = ({ userThemeEnabled }) => {
  return (
    <S.Container $userThemeEnabled={userThemeEnabled}>
      <S.Spinner $userThemeEnabled={userThemeEnabled} />
    </S.Container>
  );
};

export default ShellSpinner;
